module.exports = __webpack_public_path__ + "img/bitbox.7c33ef31.png";